import rule from './modules/rule'

const modules = {
  rule,
}

const registerModule = (module, router) => {
  if (module.router) {
    module.router(router)
  }
}

export const registerModules = router => {
  Object.values(modules).forEach(module => {
    registerModule(module, router)
  })
}

export default modules
